// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

const getAgentsBaseUrl = (userId: string) => config.AGENTS_URL.replace('{userId}', userId);

function readAllAgents(userId: string, query: string): any {
    const baseUrl = getAgentsBaseUrl(userId);
    return api.get(`${baseUrl}`, { query });
}

function createAgent(userId: string, agentRequest: any): any {
    const baseUrl = getAgentsBaseUrl(userId);
    return api.create(`${baseUrl}`, agentRequest);
}

function updateAgent(userId: string, agentId: string, agentRequest: any): any {
    const baseUrl = `${getAgentsBaseUrl(userId)}/${agentId}`;
    return api.update(`${baseUrl}`, agentRequest);
}

function deleteAgent(userId: string, agentId: string): any {
    const baseUrl = `${getAgentsBaseUrl(userId)}/${agentId}`;
    return api.delete(`${baseUrl}`);
}

export { readAllAgents, createAgent, updateAgent, deleteAgent };
